"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProductSearchDirective_1 = require("./ProductSearchDirective");
exports.ProductSearchDirective = ProductSearchDirective_1.ProductSearchDirective;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/search/directives/index.ts
// module id = 473
// module chunks = 0